import { ReactNode } from 'react';
import MuiDialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
// import { deleteProfile } from './constants/delete-profile.constant';
import { useDialogtyles } from './dialog.styles';

interface DialogProps {
  open: boolean;
  title: ReactNode;
  handleClose: () => void;
  children: ReactNode;
  dialogActions?: ReactNode;
  dividers?: boolean;
  className?: string;
  contentClassName?: string;
  skipTitleBar?: boolean;
  titleClass?: string;
  closeButtonClass?: string;
  actionsClass?: string;
  [x: string]: any;
}

export const Dialog = ({
  open,
  title,
  handleClose,
  children,
  dialogActions,
  dividers = true,
  className = '',
  contentClassName = '',
  skipTitleBar = false,
  titleClass = '',
  closeButtonClass = '',
  actionsClass = '',
  ...extraProps
}: DialogProps) => {
  const classes = useDialogtyles();

  return (
    <MuiDialog
      onClose={handleClose}
      aria-labelledby={title?.toString()}
      open={open}
      fullWidth
      className={`${classes.dialog} ${className}`}
      {...extraProps}
    >
      {!skipTitleBar && (
        <>
          <DialogTitle
            id={title?.toString()}
            className={`${classes.title} ${titleClass}`}
          >
            {title}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={`${classes.closeButton} ${closeButtonClass}`}
          >
            <CloseIcon />
          </IconButton>
        </>
      )}
      <DialogContent
        dividers={dividers}
        className={`${classes.contentBox} ${contentClassName}`}
      >
        {children}
      </DialogContent>
      {dialogActions && (
        <DialogActions className={`${classes.actions} ${actionsClass}`}>
          {dialogActions}
        </DialogActions>
      )}
    </MuiDialog>
  );
};
